// Presentation only: keep source field names, currency values and calculations.
export function withoutUzsLabel(text: string): string {
  if (!/\bUZS\b/iu.test(text)) return text;
  return text.replace(/\s*\(\s*UZS\s*\)/giu, "")
    .replace(/(?:,\s*)?\bUZS\b/giu, "")
    .replace(/[ \t]{2,}/g, " ").replace(/\s+([,.;:])/g, "$1").trim();
}
